<template>
  <div :class="$style.box">
    <TopHeader style="position: absolute" headerTitle="帖子详情" />
    <Scroll ref="scroll" :class="$style.wrapper" :pullup="true" @bsPullingUp="bsPullingUp">
      <div>
        <!-- 详情页帖子信息 -->
        <div :class="$style.topic">
          <div :class="$style['topic-title']" v-html="topicDetail.title"></div>
          <!-- 楼主信息 -->
          <div :class="$style.poster">
            <HeadImage
              :headImage="topicDetail.forum_image"
              :headCircleImage="topicDetail.identity_image"
            />
            <div :class="$style['poster-info']">
              <div :class="$style['poster-identity']">
                <p>{{ topicDetail.forum_name }}</p>
              </div>
              <p>{{ topicDetail.created_at }}</p>
            </div>
            <div :class="$style['poster-btn']">
              <button @click="handleOnlyPoster">
                {{ isOnlyPoster ? '全部回复' : '只看楼主' }}
              </button>
            </div>
          </div>
          <!-- 帖子正文部分 -->
          <div
            ref="topicContent"
            :class="$style['topic-content']"
            v-html="topicMainContent"
            v-lazy-container="{
              selector: 'img',
            }"
            @click="handleImgScale"
          ></div>
          <!-- 广告信息栏 -->
          <div :class="$style.advertising">
            <img v-lazy="circleInfo.images" />
            <div :class="$style['advertising-info']">
              <p>{{ '来自' + circleInfo.name + '游戏圈' }}</p>
              <p v-html="circleInfo.description"></p>
            </div>
            <button :class="$style['advertising-btn']" @click="handleLinkTo">进圈</button>
          </div>
        </div>
        <!-- 分隔线 -->
        <div :class="$style['divide-line']"></div>
        <CircleBaseBox
          style="box-shadow: none"
          v-if="hasHotReplyList"
          boxTitle="热门回复"
          :showBorderBottom="false"
        >
          <ReplyListItem
            v-for="item of hotReplyList"
            :key="item.id"
            :listItem="item"
            @openReplyField="openSecondReplyField"
            @openMultilevelReply="openMultilevelReply"
            @openPopup="handleReplyImgScale"
          />
        </CircleBaseBox>
        <div v-if="hasFirstReplyList" :class="$style.comments">
          <button v-if="!isOnlyPoster" :class="$style['comments-btn']" @click="toggleSortType">
            {{ sort_type == 1 ? '倒序查看' : '正序查看' }}
          </button>
          <CircleBaseBox style="box-shadow: none" boxTitle="全部回复" :showBorderBottom="false">
            <ReplyListItem
              class="ReplyListItem"
              v-for="item of firstReplyList"
              :key="item.id + ''"
              :listItem="item"
              :isFirstReply="true"
              @openReplyField="openSecondReplyField"
              @openMultilevelReply="openMultilevelReply"
              @openPopup="handleReplyImgScale"
            />
          </CircleBaseBox>
        </div>
        <!-- 无回复时显示 -->
        <div v-else :class="$style.empty">
          <div>现在还没有回复哦~</div>
          <img :src="emptyImage" />
        </div>
        <p v-if="noMoreReply && hasFirstReplyList" :class="$style['no-more-reply']">
          —— 已加载完所有数据 ——
        </p>
      </div>
    </Scroll>
    <!-- 一级回复底部虚假输入框 -->
    <ReplyFakeInput
      v-if="!showReplyField && !showMultilevelReply"
      :detail="topicDetail"
      :isFirstReply="true"
      @openReplyField="openFirstReplyField"
      @refreshDetail="refreshDetail"
    />
    <!-- 一级回复输入框 -->
    <ReplyField
      v-if="showReplyField && !showMultilevelReply"
      :isFirstReply="true"
      @refreshList="refreshList"
      @closeReplyField="closeReplyFieldFirst"
      @getCaptcha="getCaptcha"
    />
    <!-- 二级回复输入框 -->
    <ReplyField
      v-if="showSecondReplyField && !showMultilevelReply"
      :commentId="replyDetail.id"
      @refreshList="refreshList"
      @closeReplyField="showSecondReplyField = false"
      @getCaptcha="getCaptcha"
    />
    <!-- 多级回复弹窗 -->
    <MultilevelReply
      v-if="showMultilevelReply"
      :commentId="replyDetail.id"
      @closeMultilevelReply="closeMultilevelReply"
    />
    <!-- 话题查看图片弹窗 -->
    <van-popup
      v-model="showImagePopup"
      position="center"
      :overlay-style="{ backgroundColor: '#000' }"
      :lazy-render="false"
      :style="{ backgroundColor: 'transparent' }"
    >
      <div v-if="showImagePopup" :class="$style.scale" @click="showImagePopup = false">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) of imgList" :key="index" :class="$style.slide">
            <div class="swiper-zoom-container">
              <img ref="scaleImg" :src="item" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </van-popup>
    <!-- 评论查看图片弹窗 -->
    <van-popup
      v-model="showReplyImagePopup"
      position="center"
      :overlay-style="{ backgroundColor: '#000' }"
      :lazy-render="false"
      :style="{ backgroundColor: 'transparent' }"
    >
      <div v-if="showReplyImagePopup" :class="$style.scale" @click="showReplyImagePopup = false">
        <swiper :options="replySwiperOption">
          <swiper-slide v-for="(item, index) of replyImgList" :key="index" :class="$style.slide">
            <div class="swiper-zoom-container">
              <img ref="scaleImg" :src="item" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </van-popup>
    <!-- 2022.01.18新增 验证码弹窗 -->
    <van-popup v-model="captchaShow" round>
      <div :class="$style.captcha">
        <input v-model="captchaCode" type="text" placeholder="请输入下方验证码" />
        <img :src="captchaImg" />
        <p @click="getCaptcha(false)">看不清？换一张</p>
        <div>
          <div @click="clearCaptcha">取消</div>
          <div @click="sendCaptcha">提交</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import TopHeader from '_c/TopHeader';
import HeadImage from '_c/HeadImage';
import Scroll from '_c/Scroll';
import CircleBaseBox from '_c/CircleBaseBox';
import ReplyListItem from './components/ReplyListItem';
import ReplyFakeInput from './components/ReplyFakeInput';
import ReplyField from './components/ReplyField';
import MultilevelReply from './components/MultilevelReply';
import {
  getDetailTopicInfo,
  getCircleInfo,
  getDetailsHotReply,
  getReplyList,
  captchaComment,
  submitReply,
} from '@/api/gameCircle';
import { reportData } from '@/api/report';
import { CDN_URL } from '@/config/index.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import { letslazyload } from '@/utils/index.js';
import { Popup, Dialog, Toast } from 'vant';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
export default {
  components: {
    TopHeader,
    HeadImage,
    Scroll,
    CircleBaseBox,
    ReplyListItem,
    ReplyFakeInput,
    ReplyField,
    MultilevelReply,
    VanPopup: Popup,
    Swiper,
    SwiperSlide,
    Dialog,
  },
  data() {
    return {
      topicDetail: {}, // 帖子信息
      topicMainContent: '', // 帖子正文
      circleInfo: {}, // 游戏圈广告信息
      isOnlyPoster: false, // 是否只有楼主
      firstReplyList: [], // 一级回复列表
      hotReplyList: [], // 热门回复列表
      sort_type: 0, // 回复列表排序：倒序：0、正序:1
      currentPage: 1, // 回复列表当前页数
      noMoreReply: false, // 是否加载完所有回复列表
      showReplyField: false, // 显示回复编辑框
      emptyImage: `${CDN_URL}/empty.png`, // 无回复滑稽黑猫图片
      replyDetail: {}, // 一级回复信息
      showSecondReplyField: false, // 二级回复输入框
      showMultilevelReply: false, // 是否显多级回复弹窗
      // 话题
      showImagePopup: false,
      scaleImgUrl: '',
      swiperOption: {
        autoHeight: true,
        zoom: {
          toggle: false,
        },
        initialSlide: 0,
      },
      imgList: [],
      // 评论
      showReplyImagePopup: false,
      replyScaleImgUrl: '',
      replySwiperOption: {
        autoHeight: true,
        zoom: {
          toggle: false,
        },
        initialSlide: 0,
      },
      replyImgList: [],
      captchaShow: false, // 验证码弹窗
      captchaImg: '', // 验证码链接
      captchaCode: '', // 输入的验证码
      captchaData: undefined, // 验证码回传过来的评论提交数据
      firstReplyFlag: false, // 是否是一级回复
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false;
      return flag;
    },
    // 游戏圈id
    circleId() {
      return this.$route.query.circleId;
    },
    // 是否是通过复制链接扫描二维码进来
    reportType() {
      return this.$route.query.reportType;
    },
    // 帖子id
    conversationId() {
      return this.$route.query.id;
    },
    // 活动页跳转过来的id
    actId() {
      return this.$route.query.actId;
    },
    hasHotReplyList() {
      return this.hotReplyList.length > 0 ? true : false;
    },
    hasFirstReplyList() {
      return this.firstReplyList.length > 0 ? true : false;
    },
  },
  created() {
    const prohibition = this.userInfo.prohibition;
    if (prohibition.state_type == 1) {
      let warnMsg = `您的论坛账号已被封禁\n 封禁时间：${
        prohibition.time_type == 1 ? '永久' : prohibition.start_time + '~' + prohibition.end_time
      }\n如有疑问请联系客服`;
      Dialog.alert({
        title: '温馨提示',
        message: warnMsg,
      }).then(() => {
        this.$router.push({ name: 'gameCircleCenter.home' });
      });
      return;
    }
    const reportObj = {
      type: 5,
      data_type: 1,
      circle_id: this.circleId,
      conversation_id: this.conversationId,
      report_type: this.reportType ? 2 : 1,
    };
    this.actId != '' && (reportObj.extend = this.actId);
    reportData(reportObj);
    this.getCircleInfo();
    this.getDetailTopicInfo();
    this.getDetailsHotReply();
    this.getReplyList();
  },
  mounted() {
    this.CHANGE_TOPIC_ID(this.$route.query.id);
  },
  methods: {
    ...mapMutations('gameCircle', {
      CHANGE_TOPIC_ID: 'CHANGE_TOPIC_ID',
      CHANGE_CAN_COMMENT: 'CHANGE_CAN_COMMENT',
    }),
    ...mapMutations('app', {
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
    }),
    // 2022.01.18新增 获取验证码
    async getCaptcha(data) {
      data && (this.captchaData = data);
      const r = await captchaComment({});
      if (r.code !== 1) return;
      this.captchaImg = r.data.captcha;
      this.captchaShow = true;
    },
    clearCaptcha() {
      this.captchaShow = false;
      this.captchaCode = '';
      this.captchaImg = '';
      this.captchaData = undefined;
    },
    // 点击验证码提交
    async sendCaptcha() {
      if (this.captchaCode == '') {
        Toast.fail('请输入验证码~');
        return;
      }
      try {
        const r = await submitReply(
          Object.assign({}, this.captchaData, { captcha: this.captchaCode }),
        );
        this.clearCaptcha();
        Toast('评论成功');
        this.refreshList();
      } catch (error) {
        console.log(error);
        if (error.code === 0) {
          Toast.fail(error.message);
          return;
        }
      }
    },
    // 获取帖子所属游戏圈信息
    async getCircleInfo() {
      const r = await getCircleInfo({ game_circle_id: this.circleId });
      this.circleInfo = { ...r.data };
    },
    // 获取帖子详情
    async getDetailTopicInfo() {
      const r = await getDetailTopicInfo({
        conversation_id: this.conversationId,
      });
      this.topicDetail = { ...r.data };
      this.CHANGE_CAN_COMMENT(this.topicDetail.can_comment);
      if (!this.topicDetail.content) {
        this.topicMainContent = '';
        return;
      }
      // 给正文中添加的链接加一个点击事件
      if (this.topicDetail.content.indexOf('<a href') !== -1) {
        let el = document.createElement('div');
        el.innerHTML = this.topicDetail.content;
        // let aList = el.getElementsByTagName('a');
        // for (const item of aList) {
        //   this.topicDetail.content = this.topicDetail.content.replace(
        //     '<a',
        //     `<a onclick="window.location.href='${item.href}'"`,
        //   );
        // }
      }
      // 替换后台编辑框中默认修改的图片样式
      let reg = /img style="width:auto; height:350px;|img style="width: auto; height: 350px;/gi;
      this.topicDetail.content = this.topicDetail.content.replace(
        reg,
        'img style="width: 100%; height: auto;',
      );
      this.topicMainContent = letslazyload(this.topicDetail.content);
      // 获取正文中所有的图片链接
      let el = document.createElement('div');
      el.innerHTML = this.topicDetail.content;
      let imgNodeList = el.getElementsByTagName('img');
      for (const item of imgNodeList) {
        this.imgList.push(item.src);
      }
      this.scaleImgUrl = this.imgList[0]; // 默认选择第一张图片
    },
    // 获取热门回复列表
    async getDetailsHotReply() {
      const r = await getDetailsHotReply({
        conversation_id: this.conversationId,
      });
      this.hotReplyList = [...r.data];
    },
    // 获取帖子详情页一级回复列表
    async getReplyList() {
      let data = {
        limit: 10,
        page: this.currentPage,
        conversation_id: this.conversationId,
        sort: this.sort_type,
        is_publisher: this.isOnlyPoster ? 1 : 0, // 是否只看楼主
      };
      this.CHANGE_SHOW_LOADING(true);
      const r = await getReplyList(data);
      // 加载列表为空
      if (!r.data.length) {
        this.noMoreReply = true;
      }
      if (this.currentPage == 1) {
        this.firstReplyList = [...r.data];
      } else {
        this.firstReplyList = this.firstReplyList.concat([...r.data]);
      }
      this.CHANGE_SHOW_LOADING(false);
      setTimeout(() => {
        this.$refs.scroll.refresh();
      }, 10);
    },
    // 获取帖子详情页一级回复列表 - 第一页数据（仅限正序查看新增回复）
    async getReplyListFirstData() {
      let data = {
        limit: 10,
        page: 1,
        conversation_id: this.conversationId,
        sort: 0,
        is_publisher: 0, // 是否只看楼主
      };
      this.CHANGE_SHOW_LOADING(true);
      const r = await getReplyList(data);
      // 加载列表为空
      if (!r.data.length) {
        this.noMoreReply = true;
      } else {
        this.firstReplyList.splice(0, 0, r.data[0]);
      }
      this.CHANGE_SHOW_LOADING(false);
      setTimeout(() => {
        this.$refs.scroll.scrollToElement(document.querySelector('.ReplyListItem'), 200);
        this.$refs.scroll.refresh();
      }, 10);
    },
    // 进入游戏圈
    async handleLinkTo() {
      try {
        const r = await reportData({
          type: 5,
          data_type: 3,
          circle_id: this.circleId,
          conversation_id: this.conversationId,
        });
      } catch (error) {
        console.log(error);
      }
      this.$router.push({ name: 'gameCircle.home', query: { circleId: this.circleId, noSearch: '1' } });
    },
    // 上拉加载
    bsPullingUp() {
      this.currentPage++;
      setTimeout(() => {
        this.getReplyList();
      }, 10);
    },
    // 切换排序类型
    toggleSortType() {
      reportData({
        type: 5,
        data_type: 4,
        circle_id: this.circleId,
        conversation_id: this.conversationId,
      });
      this.sort_type = this.sort_type == 1 ? 0 : 1;
      this.currentPage = 1;
      setTimeout(() => {
        this.getReplyList();
      }, 10);
    },
    // 点击只看楼主
    handleOnlyPoster() {
      reportData({
        type: 5,
        data_type: 2,
        circle_id: this.circleId,
        conversation_id: this.conversationId,
      });
      this.isOnlyPoster = this.isOnlyPoster == 1 ? 0 : 1;
      this.currentPage = 1;
      this.getReplyList();
    },
    // 刷新回复列表
    refreshList() {
      // 总回复加1
      this.topicDetail.comment++;
      // 只看楼主 或者 倒序查看 - 刷新列表只显示评论成功，不请求数据
      if (this.sort_type === 1 || this.isOnlyPoster === true) return;
      setTimeout(() => {
        // 只要 type 为1时，执行获取第一页数据操作
        if (this.firstReplyFlag === true) {
          this.getReplyListFirstData();
        } else {
          // 否则筛选列表，回复数加1
          const currentId = this.replyDetail['id'] ? this.replyDetail['id'] : 0;
          const currentIndex = this.firstReplyList.findIndex((m) => m.id == currentId);
          this.firstReplyList[currentIndex]['comment']++;
        }
        this.firstReplyFlag = false;
      }, 300);
    },
    // 点赞后点赞数加1
    refreshDetail() {
      this.topicDetail.is_support = 1;
      this.topicDetail.support++;
    },
    // 打开一级回复框
    openFirstReplyField() {
      this.showReplyField = true;
      this.firstReplyFlag = true;
    },
    // 关闭一级回复框
    closeReplyFieldFirst() {
      this.showReplyField = false;
    },
    // 打开二级回复框
    openSecondReplyField(replyItem) {
      this.replyDetail = { ...replyItem };
      setTimeout(() => {
        this.showSecondReplyField = true;
      }, 10);
    },
    // 打开多级回复弹窗
    openMultilevelReply(replyItem) {
      this.replyDetail = { ...replyItem };
      setTimeout(() => {
        this.showMultilevelReply = true;
      }, 10);
    },
    // 关闭多级回复
    closeMultilevelReply() {
      this.showMultilevelReply = false;
    },
    // 话题中点击图片放大缩小
    handleImgScale(e) {
      this.scaleImgUrl = e.target.src;
      let imgIndex = this.imgList.findIndex((item) => this.scaleImgUrl == item);
      this.$set(this.swiperOption, 'initialSlide', imgIndex == -1 ? 0 : imgIndex);
      imgIndex !== -1 && (this.showImagePopup = true);
    },
    // 评论中点击图片放大缩小
    handleReplyImgScale(obj) {
      this.replyScaleImgUrl = obj.currentImage;
      this.replyImgList = [...obj.replyImageList];
      let imgIndex = this.replyImgList.findIndex((item) => this.replyScaleImgUrl == item);
      this.$set(this.replySwiperOption, 'initialSlide', imgIndex == -1 ? 0 : imgIndex);
      this.showReplyImagePopup = true;
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-x: hidden;
  .wrapper {
    position: relative;
    margin-top: 44px;
    width: 100%;
    height: calc(100vh - 94px);
    .no-more-reply {
      color: #9f9f9f;
      text-align: center;
      font-size: 14px;
      padding: 10px 0;
    }
    .divide-line {
      width: 100%;
      height: 5px;
      background: rgba(239, 239, 239, 1);
    }
  }
}
.topic {
  width: 100%;
  padding: 0 17px 17px 17px;
  .topic-title {
    width: 100%;
    min-height: 30px;
    text-align: left;
    line-height: 30px;
    font-size: 18px;
    font-weight: bold;
  }
  .poster {
    margin-top: 15px;
    width: 348px;
    display: flex;
    .poster-info {
      position: relative;
      left: -8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .poster-identity {
        width: 189px;
        line-height: 14px;
        font-size: 15px;
        p:first-child {
          font-weight: bold;
        }
      }
      > p {
        margin-top: 12px;
        float: left;
        width: 169px;
        height: 8px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(159, 159, 159, 1);
      }
    }
    .poster-btn {
      position: relative;
      left: 35px;
      > button {
        @include clearBtnDefaultStyle;
        margin-top: 13px;
        width: fit-content;
        height: 17px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        color: rgba(40, 169, 251, 1);
        border: 1px solid rgba(40, 169, 251, 1);
        border-radius: 9px;
      }
    }
  }
  .topic-content {
    margin-top: 9px;
    width: 340px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    overflow: hidden;
    white-space: pre-line;
    img {
      width: 100%;
      height: auto;
      margin: 5px auto;
    }
    // 使用属性选择器选择表情图片
    img[src*='plugins/emoticons'] {
      width: 18px;
      height: 18px;
      margin: 0;
    }
  }
  .advertising {
    width: 340px;
    height: 66px;
    margin-top: 14px;
    background: rgba(237, 237, 237, 1);
    border-radius: 7px;
    padding: 6px 10px 6px 7px;
    font-size: 12px;
    & > img {
      width: 54px;
      float: left;
      margin-right: 12px;
    }
    .advertising-info {
      width: 170px;
      float: left;
      margin-top: 9px;
      font-weight: 400;
      & > p:nth-child(1) {
        font-size: 13px;
        color: rgba(0, 0, 0, 1);
        line-height: 13px;
      }
      & > p:nth-child(2) {
        color: rgba(159, 159, 159, 1);
        font-size: 11px;
        line-height: 13px;
        margin-top: 9px;
      }
    }
    .advertising-btn {
      @include clearBtnDefaultStyle;
      width: 68px;
      line-height: 31px;
      background: linear-gradient(-75deg, rgba(255, 73, 73, 1), rgba(255, 143, 94, 1));
      border-radius: 15px;
      float: right;
      font-size: 12px;
      font-weight: 400;
      color: white;
      text-align: center;
      margin-top: 12px;
    }
  }
}
.comments {
  .comments-btn {
    position: absolute;
    z-index: 30;
    right: 15px;
    margin-top: 10px;
    @include clearBtnDefaultStyle;
    font-size: 14px;
    color: rgba(40, 169, 251, 1);
  }
}
.empty {
  width: 100%;
  height: 300px;
  > div {
    position: relative;
    top: 43px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    margin-bottom: 13px;
    width: 100%;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
    line-height: 13px;
  }
  > img {
    position: relative;
    top: 43px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    width: 218px;
    height: auto;
  }
}
.scale {
  width: 375px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  > img {
    width: 100%;
    height: auto;
  }
  .slide {
    width: 100vw;
    height: 100vh;
  }
}
.captcha {
  width: 326px;
  height: 240px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 23px;
  > input {
    width: 230px;
    height: 47px;
    background: #f5f5f5;
    border-radius: 24px;
    padding-left: 26px;
  }
  > img {
    width: 108px;
    height: 41px;
    margin: 18px 0px 8px 0px;
  }
  > p {
    width: 86px;
    height: 12px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #a9a9a9;
    line-height: 22px;
    text-decoration: underline;
    margin-bottom: 18px;
  }
  > div {
    width: 100%;
    height: 42px;
    display: flex;
    justify-content: space-between;
    padding: 0px 40px;
    > div {
      width: 111px;
      height: 42px;
      border-radius: 21px;
      line-height: 42px;
      text-align: center;
      font-size: 17px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
    > div:nth-child(1) {
      background-color: #ffffff;
      color: #818181;
      border: 1px solid #818181;
    }
    > div:nth-child(2) {
      background-color: #63aded;
      color: #ffffff;
    }
  }
}
</style>

